// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#2f184c","secondaryColor":"#b94860","lightBlue":"#e3e7ef","lightGrey":"#c3c3c3"};